export default {
  data () {
    return {
      folioRhInfo: null,
      folioRhError: '',
      validandoFolioRh: false,
      _debounceFolioRh: null
    }
  },

  beforeDestroy () {
    if (this._debounceFolioRh) clearTimeout(this._debounceFolioRh)
  },

  methods: {
    esFolioRhTexto (valor) {
      return /^RH-?\d*$/i.test(String(valor || '').trim())
    },

    esFolioRhCompleto (valor) {
      return /^RH-\d+$/i.test(this.normalizarFolioRh(valor))
    },

    normalizarFolioRh (valor) {
      return String(valor || '').trim().toUpperCase()
    },

    onFolioRhInput (valor, aplicar) {
      if (this._debounceFolioRh) clearTimeout(this._debounceFolioRh)
      this._debounceFolioRh = setTimeout(() => {
        this.validarFolioRh(valor, aplicar)
      }, 400)
    },

    async validarFolioRh (valor, aplicar) {
      const folio = this.normalizarFolioRh(valor)
      this.folioRhError = ''
      this.folioRhInfo = null
      if (!folio) return null
      if (!/^RH-\d+$/.test(folio)) {
        this.folioRhError = 'Formato inválido. Usa RH-00001'
        return null
      }
      this.validandoFolioRh = true
      try {
        const res = await this.$http.get('becas.trabajador.validar-folio/' + encodeURIComponent(folio))
        const data = (res && (res.body || res.data)) || {}
        if (!data.valid) {
          this.folioRhError = data.message || 'Folio RH no válido'
          return null
        }
        this.folioRhInfo = data
        if (typeof aplicar === 'function') aplicar(data)
        return data
      } catch (err) {
        const msg = (err.body && err.body.message)
          || (err.response && err.response.data && err.response.data.message)
          || 'Folio RH no válido o inactivo'
        this.folioRhError = msg
        return null
      } finally {
        this.validandoFolioRh = false
      }
    }
  }
}
